import http from './http';
// 获取年度报告2021
export const getReportYearData = (params, config = {}) => http.get('/cfmotoservervehicle/user/vehicle/poster/info', { params, ...config });
// 年度报告2022
export const posterInfo2022Api = (params, config = {}) => http.get('/cfmotoservervehicle/app/user/vehicle/poster/2022/info', { params, ...config });
export const posterInfo2022CodeApi = (params, config = {}) => http.get('/cfmotoservervehicle/app/user/vehicle/poster/2022/share-code', { params, ...config });
export const posterInfo2022ChallengeApi = (params, config = {}) => http.patch(`/cfmotoservervehicle/app/user/vehicle/poster/2022/${params.id}/challenge`, params, { ...config });

// 年度报告2024
export const posterInfo2024Api = (params, config = {}) => http.get('/cfmotoservervehicle/app/user/vehicle/poster/2024/info', { params, ...config });
export const posterInfo2024CodeApi = (params, config = {}) => http.get('/cfmotoservervehicle/app/user/vehicle/poster/2024/share-code', { params, ...config });

export default {};
